import { useEffect, useState } from 'react';
import { magicNumbers } from 'utils';

const useDefineBreakPoint = (
  maxWidthTablet = magicNumbers?.TABLET_BREAK_POINT,
  maxWidthMobile = magicNumbers?.MOBILE_BREAK_POINT
) => {
  const [breakPoint, setBreakPoint] = useState(null);

  useEffect(() => {
    const tabletMediaQuery = window.matchMedia(
      `(max-width: ${maxWidthTablet}px)`
    );
    const mobileMediaQuery = window.matchMedia(
      `(max-width: ${maxWidthMobile}px)`
    );

    const handleMediaQueryChange = () => {
      if (mobileMediaQuery.matches) {
        setBreakPoint(magicNumbers?.MOBILE_BREAK_POINT);
      } else if (tabletMediaQuery.matches) {
        setBreakPoint(magicNumbers?.TABLET_BREAK_POINT);
      } else {
        setBreakPoint(null);
      }
    };

    handleMediaQueryChange();
    tabletMediaQuery.addEventListener('change', handleMediaQueryChange);
    mobileMediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      tabletMediaQuery.removeEventListener('change', handleMediaQueryChange);
      mobileMediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, [maxWidthTablet, maxWidthMobile]);

  return breakPoint;
};

export default useDefineBreakPoint;
